//event admin
export const inner_route_allEvents = "/eventtags/events";
export const inner_route_event_sub_events = "/eventtags/events/subevents";
export const inner_route_event_sub_events_sub_event ="/eventtags/events/subevents/subevent";
export const inner_route_events_event = "/eventtags/events/event";

//corporate admin
export const cor_inner_route_allEvents = "/corporate/eventtags/events";
export const cor_inner_route_event_sub_events = "/corporate/eventtags/events/subevents";
export const cor_inner_route_event_sub_events_sub_event ="/corporate/eventtags/events/subevents/subevent";
export const cor_inner_route_events_event = "/corporate/eventtags/events/event";
